import React from 'react'
import Navbar from '../Navbar/Header.jsx'
import Footer from '../Footer/Footer.jsx'
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import '../../styles/main.css';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import Home from '../../pages/Home/Home.jsx'
import TopNav from '../Navbar/TopNav.jsx'
import 'font-awesome/css/font-awesome.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import About from '../../pages/About/About.jsx';
import HowItWork from '../../pages/Howitwork/HowItWorks.jsx';
import Pricing from '../../pages/Pricing/Pricing.jsx';
import Legal from '../../pages/Legal/Legal.jsx';
import Blog from '../../pages/Blog/Blog.jsx';
import PopularStories from '../../pages/Blog/PopularStories.jsx';
import BLogDetails from '../../pages/Blog/BLogDetails.jsx';
import VirtualCard from '../../pages/Virtual/VirtualCard.jsx';
import VirtualAccount from '../../pages/Virtual/VirtualAccount.jsx';
import SendMoney from '../../pages/Virtual/SendMoney.jsx';
import PaymentLink from '../../pages/Virtual/PaymentLink.jsx';
import AirtimeBillPayment from '../../pages/Virtual/AirtimeBillPayment.jsx';
import BusinessAccount from '../../pages/Virtual/BusinessAccount.jsx';
import Contact from '../../pages/Contact/Contact.jsx';
import HelpCentre from '../../pages/Help/HelpCentre.jsx';
import Faq from '../../pages/FAQ/Faq.jsx';
import Career from '../../pages/Career/Career.jsx';
import ScrollToTop from '../../hooks/ScrollToTop.js';
import LeaderboardPage from '../../pages/Leaderboard/Leaderboard.js';
import CareerDetails from '../../pages/Career/CareerDetails.jsx';
import HelpInfoByCategory from '../../pages/Help/HelpInfoByCategory.jsx';
import NotFound from '../../pages/NotFound/NotFound';
import Aml from '../../pages/AML/aml.jsx';
import Privacypolicy from '../../pages/Privacypolicy/privacy-policy.jsx';



function Main() {
    const location = useLocation();
    const isHomePage = location.pathname === '/';

  return (
    <div className='content'>
        <header className='sticky-top'>
          {isHomePage && <TopNav />}
          <Navbar />
        </header>

        <ScrollToTop />

          <Routes>
            <Route path=''  element={ <Home />} />
            <Route path='/about' element={ <About /> } />
            <Route path='/how-it-works' element={ <HowItWork />} />
            <Route path='/pricing' element={ <Pricing />} />
            <Route path='/legal' element={ <Legal />} />
            <Route path='/blog' element={ <Blog />} />
            <Route path='/blog/popular-stories' element={ <PopularStories />} />
            <Route path='/blog/details' element={ <BLogDetails  />} />
            <Route path='/virtual-card' element={ <VirtualCard />} />
            <Route path='/virtual-account' element={ <VirtualAccount />} />
            <Route path='/send-money' element={ <SendMoney />} />
            <Route path='/payment-link' element={ <PaymentLink />} />
            <Route path='/airtime-bill-payment' element={ <AirtimeBillPayment />} />
            <Route path='/business-account' element={ <BusinessAccount />} />
            <Route path='/contact' element={ <Contact />} />
            <Route path='/help' element={ <HelpCentre /> } />
            <Route path='/help/category/:categoryID' element={ <HelpInfoByCategory /> } />
            <Route path='/faq' element={ <Faq />} />
            <Route path='/career' element={ <Career />} />
            <Route path="/careers/:roleId" element={<CareerDetails />} />
            <Route path='/leaderboard' element={<LeaderboardPage />} />
            {/* <Route path='/blog' element={ <Blog />} /> */}
            <Route path='/aml' element={ <Aml />} />
            <Route path='/privacy-policy' element={ <Privacypolicy />} />

            {/* Catch-all Route */}
            {/* <Route path="*" element={<Navigate to="/" />} /> */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        <Footer />
    </div>
  )
}

export default Main
